import React, { Fragment } from 'react';
import { List, Datagrid, DatagridBody, TextField, ImageField, NumberField, TopToolbar, RefreshButton,useRecordContext, usePermissions } from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import { TableRow, TableCell, TableFooter } from '@mui/material';
import { getCurrencySymbol, getLocalStorageKey } from '../common/common';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ListActions = () => (
    <TopToolbar>
        <RefreshButton />
    </TopToolbar>
)

const MaterialQtyUom = () => {
    // console.log('record ===>', record)
    const record = useRecordContext();

    return record['ordered_quantity'] ? <span> {record['ordered_quantity']} {(record['ordered_qty_uom'] === 'TON' || record['ordered_qty_uom'] === 'TN') ? 'T' : record['ordered_qty_uom']} </span> : "-"
}

const QuantityField = ({  showBags }) => {
    const record = useRecordContext();

   return <span>{(record.ordered_quantity && (showBags ? record.ordered_quantity * record.product_master.conversion_factor : record.ordered_quantity)) || 0}</span>
}

const UomField = ({  showBags }) => {
    const record = useRecordContext();

   return <span>{showBags ? record.product_master.conversion_uom_name : record.product_master.input_uom_name}</span>
}

const LoadedQuantityField = ({  showBags }) => {
    const record = useRecordContext();

    return <span>{(record.loaded_quantity && (showBags ? record.loaded_quantity * 20 : record.loaded_quantity)) || 0}</span>
}

const ReturnedQuantityField = ({  showBags }) => {
    const record = useRecordContext();

    return<span>{(record.returned_quantity && (showBags ? record.returned_quantity * 20 : record.returned_quantity)) || 0}</span>
}

const TargetQuantityField = ({  showBags }) => {
    const record = useRecordContext();

   return <span>{(record.target_quantity && (showBags ? record.target_quantity * 20 : record.target_quantity)) || 0}</span>
}

const AmountField = ({  source }) => {
    const record = useRecordContext();

    console.log("record TotalCostPerItemField",record);

    return record[source] ? <span>{record['currency']} {record[source]}</span> : "-"
}

const TotalCostPerItemField = () => {
    const record = useRecordContext();

    const totalCostPerItem = (((Number(record.netValue) / Number(record.target_quantity)) * record.ordered_quantity) +
        ((Number(record.vat_percentage) / 100) * ((Number(record.netValue) / Number(record.target_quantity)) * record.ordered_quantity))).toFixed(2)
        console.log('totalCostPerItem==>', totalCostPerItem);
    if (totalCostPerItem && !isNaN(totalCostPerItem)) {
        return (<span>{record.currency} {totalCostPerItem}</span>)
    }
    return (<span>-</span>);
}

const CustomDataGridBody = ({ permissions, ...props }) => {
    console.log("props ",props)
    let total_ordered_quantity = 0;
    let total_ordered_quantity_bags = 0;
    let total_loaded_quantity = 0;
    let total_loaded_quantity_bags = 0;
    // let total_delivered_quantity = 0;
    let total_returned_quantity = 0;
    let total_returned_quantity_bags = 0;
    let total_target_quantity = 0;
    let total_target_quantity_bags = 0;
    let total_netValue = 0;
    let total_cost_per_item = 0;
    let total_cost = 0;
    const hideVatInput = getLocalStorageKey('hide_vat_input') || false;
    let currency;
    props.data.forEach(id => {
        console.log("props id",id?.netValue)
        currency = id?.currency;
        total_ordered_quantity += id.ordered_quantity || 0;
        total_ordered_quantity_bags += (id.ordered_quantity * id.product_master.conversion_factor) || 0;
        total_loaded_quantity += id.loaded_quantity || 0;
        total_loaded_quantity_bags += (id.loaded_quantity * 20) || 0;
        // total_delivered_quantity += id.delivered_quantity || 0;
        total_returned_quantity += id.returned_quantity || 0;
        total_returned_quantity_bags += (id.returned_quantity * 20) || 0;
        total_target_quantity += id.target_quantity || 0;
        total_target_quantity_bags += (id.target_quantity * 20) || 0;
        total_netValue += id.netValue || 0;
        total_cost_per_item = (((Number(id.netValue) / Number(id.target_quantity)) * id.ordered_quantity) +
            ((Number(id.vat_percentage) / 100) * ((Number(id.netValue) / Number(id.target_quantity)) * id.ordered_quantity))).toFixed(2)
        total_cost += Number(total_cost_per_item) || 0;
    });
    return (
        <Fragment>
            <DatagridBody {...props} />
            <TableFooter className="sap-materials-total">
                <TableRow>
                    <TableCell className="total-label">
                        Total
                    </TableCell>
                    <TableCell>
                    </TableCell>
                    <TableCell>
                    </TableCell>
                    <TableCell>
                        {total_ordered_quantity}
                    </TableCell>
                    <TableCell>
                    </TableCell>
                    {/* <TableCell>
                        {total_ordered_quantity_bags}
                    </TableCell> */}
                    {/* <TableCell>
                    </TableCell> */}
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                            {total_loaded_quantity}
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                            {total_loaded_quantity_bags}
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                            {total_returned_quantity}
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                            {total_returned_quantity_bags}
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                            {total_target_quantity}
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                            {total_target_quantity_bags}
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                        </TableCell>
                    }
                    {
                        permissions === 'isSap' &&
                        <TableCell>
                        </TableCell>
                    }
                    <TableCell>
                        {currency} {total_netValue}
                    </TableCell>
                    {
                        !hideVatInput &&
                        <TableCell>
                        </TableCell>
                    }
                    {
                        permissions !== 'isSageAPI' &&
                        <TableCell>
                            {currency} {total_cost}
                        </TableCell>
                    }
                </TableRow>
            </TableFooter>
        </Fragment>
    )
}

const SapMaterialsForSdosList = ({ ...props }) => {
    const permissions = usePermissions();
    const hideVatInput = getLocalStorageKey('hide_vat_input') || false;
    return (
        <Scrollbars>
            <List {...props} actions={<ListActions />} pagination={null} title="Materials for SDOs" bulkActionButtons={false}>
                <Datagrid bulkActionButtons={false} body={<CustomDataGridBody permissions={permissions.permissions} />}>
                    <ImageField label="Product Image" source="product_master.image_data" title="title" />
                    <TextField source="material_no" label="Material No." />
                    <TextField label="Product Name" source="product_master.description" />
                    <QuantityField label="Ordered Qty" />
                    <UomField label="Ordered UOM" />
                    {/* <QuantityField label="Conversion Qty" showBags />
                <UomField label="Conversion UOM" showBags /> */}
                    {
                        permissions.permissions === 'isSap' &&
                        <NumberField source="ordered_uom_numerator" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <NumberField source="ordered_uom_denominator" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <LoadedQuantityField label="Loaded Qty (Tons)" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <LoadedQuantityField label="Loaded Qty (Bags)" showBags />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <ReturnedQuantityField label="Returned Qty (Tons)" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <ReturnedQuantityField label="Returned Qty (Bags)" showBags />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <TargetQuantityField label="Target Qty (Tons)" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <TargetQuantityField label="Target Qty (Bags)" showBags />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <NumberField source="target_uom_numerator" label="Target UOM (Numerator)" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <NumberField source="target_uom_denominator" label="Target UOM (Denominator)" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <NumberField source="lr_uom_numerator" label="LR UOM (Numerator)" />
                    }
                    {
                        permissions.permissions === 'isSap' &&
                        <NumberField source="lr_uom_denominator" label="LR UOM (Denominator)" />
                    }
                    <AmountField source="netValue" label="Unit Price" />
                    {
                        !hideVatInput &&
                        <TextField label="VAT (%)" source="vat_percentage" />
                    }
                    {
                        permissions.permissions !== 'isSageAPI' &&
                        <TotalCostPerItemField label="Total Cost Per Item"  />
                    }
                </Datagrid>
            </List>
        </Scrollbars>
    )
}

export default SapMaterialsForSdosList;